export const documentTypeOptions = {
  DOCUMENT: { GOOGLE: "document", MICROSOFT: "microsoft_word" },
  SPREADSHEET: { GOOGLE: "spreadsheet", MICROSOFT: "microsoft_excel" },
  PRESENTATION: {
    GOOGLE: "presentation",
    MICROSOFT: "microsoft_powerpoint",
  },
};
